import Icon from '../components/Icon.vue'

Icon.register({
  memory: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 130.9c-18.6 6.6-32 24.2-32 45.1s13.4 38.5 32 45.1v98.9h-640v-98.9c18.6-6.6 32-24.2 32-45.1s-13.4-38.5-32-45.1v-34.9c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32v34.9zM224 256v-128h-64v128h64zM352 256v-128h-64v128h64zM480 256v-128h-64v128h64zM0 448v-96h640v96h-64v-26.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v26.7h-128v-26.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v26.7h-128v-26.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v26.7h-128v-26.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v26.7h-64z'
      }
    ]
  }
})
